import { useState } from "react";
import { CustomDataTable } from "components/Structure/DataTable/customDataTable";
import { useProductsIgnored } from "useCases/products";
import { columns } from "./columns";

export const ListIgnoredProducts = () => {
  const [page, setPage] = useState(1);

  const { data, isLoading, revalidate } = useProductsIgnored({ page });

  return (
    <CustomDataTable
      pagination
      paginationServer
      responsive
      progressPending={isLoading}
      columns={columns(revalidate)}
      data={data?.data || []}
      totalPages={data?.totalPages}
      page={page}
      handlePageChange={setPage}
      titleError="Nenhum produto ignorado encontrado"
      paginationDefaultPage={page}
    />
  );
};
